// Runtime loader for Tabac-Sans. Ported from v1 app/scripts/font-loader.js
// as an ES module; behavior is unchanged - fonts load via the FontFace API,
// then the `fonts-loaded` class on <html> lets the stylesheet switch
// --font-family to Tabac-Sans (see @martinus/styles base/_globals.scss).
//
// The base URL is a parameter instead of the hardcoded relative path v1 used,
// so consumers can point it at wherever they serve the font files from.

const FACES = [
  { file: 'Tabac-Sans-Regular-9531409e5f6d548c2ccc3429d9d5db69', weight: 'normal', style: 'normal' },
  { file: 'Tabac-Sans-Italic-939c7bc3092f331c10e75335f85f45a5', weight: 'normal', style: 'italic' },
  { file: 'Tabac-Sans-SemiBold-c1c5cd189c25eb46746c1d6648f58103', weight: '600', style: 'normal' },
  { file: 'Tabac-Sans-SemiBold-Italic-995d174f745ccf34d9668fc3949054e0', weight: '600', style: 'italic' },
  { file: 'Tabac-Sans-Bold-0434c8d811e4abf9f73aab8061622b1a', weight: '700', style: 'normal' },
];

export default function loadFonts(fontsBaseUrl = '/fonts/Tabac-Sans/fonts/') {
  if (sessionStorage.getItem('customFontLoaded')) {
    document.documentElement.classList.add('fonts-loaded');
    return Promise.resolve();
  }

  if (!('fonts' in document)) {
    return Promise.resolve();
  }

  const faces = FACES.map(
    ({ file, weight, style }) =>
      new FontFace(
        'Tabac-Sans',
        `url('${fontsBaseUrl}${file}.woff2') format('woff2'),
         url('${fontsBaseUrl}${file}.woff') format('woff')`,
        { weight, style, display: 'swap' },
      ),
  );

  return Promise.all(faces.map((face) => face.load())).then((loadedFonts) => {
    loadedFonts.forEach((loadedFont) => {
      document.fonts.add(loadedFont);
    });
    document.documentElement.classList.add('fonts-loaded');
    sessionStorage.setItem('customFontLoaded', 'true');
  });
}
